'use strict';

var component = angular.module('saturn.layout.nav.view', []);

var ViewDirective = require('./ViewDirective');
var ViewController = require('./ViewController');

component.controller('sbNavDrawerPageViewController', [
  'sbNavDrawerService',
  ViewController
]);

component.directive('sbNavDrawerPageView', [
  '$animate',
  '$window',
  ViewDirective
]);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/view/index.js